import { render, staticRenderFns } from "./bulletinBoard.vue?vue&type=template&id=f188f4c8&scoped=true"
import script from "./bulletinBoard.vue?vue&type=script&lang=js"
export * from "./bulletinBoard.vue?vue&type=script&lang=js"
import style0 from "./bulletinBoard.vue?vue&type=style&index=0&id=f188f4c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f188f4c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f188f4c8')) {
      api.createRecord('f188f4c8', component.options)
    } else {
      api.reload('f188f4c8', component.options)
    }
    module.hot.accept("./bulletinBoard.vue?vue&type=template&id=f188f4c8&scoped=true", function () {
      api.rerender('f188f4c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/customManage/bulletinBoard.vue"
export default component.exports